var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.c0addcd1096911540d3a71f441f9f97d.svg#bh';
                    var viewUrl = 'sprites.c0addcd1096911540d3a71f441f9f97d.svg#view-bh';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 63 29',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };